package dev.lingvo.ops.state

fun ledgerNotice(periodStart: String, ledgerBegins: String): String? =
    if (periodStart < ledgerBegins) {
        "Credits before $ledgerBegins were not recorded; this ledger does not claim anything about them."
    } else {
        null
    }
